import React, { memo, useContext } from 'react';
import Markdown from '../../../components/shared/Markdown';
import { safetyCheck } from '../../../utils';
import PageContext from '../../../contexts/PageContext';

const AnalyticalA = () => {
    const { data, heading: Heading } = useContext( PageContext );

    return (
        safetyCheck( data.analytical, 'body' ) && (
            <div>
                <Heading>{data.analytical.heading}</Heading>
                <Markdown className="markdown text-sm">{data.analytical.body}</Markdown>
            </div>
        )
    );
};

export default memo( AnalyticalA );
